var map = {
	"./FCbg.png": 167,
	"./audio.svg": 168,
	"./boxIcon.png": 169,
	"./cookie-preview.svg": 51,
	"./cookie1.svg": 24,
	"./cookie2.svg": 25,
	"./cookie3.svg": 26,
	"./cookie4.svg": 27,
	"./cookie5.svg": 28,
	"./cookie6part1.svg": 91,
	"./cookie6part2.svg": 92,
	"./discardbox_closed.png": 96,
	"./discardbox_open.png": 97,
	"./discardbox_quarterview.png": 99,
	"./dropbox.svg": 170,
	"./explore-background.jpg": 171,
	"./exposition/text1.png": 100,
	"./exposition/text2.png": 101,
	"./fieldbook/cassette.png": 172,
	"./fieldbook/smallCassette.png": 53,
	"./fieldbook_icon.png": 52,
	"./fishing/textleftl.png": 40,
	"./fishing/textleftw.png": 38,
	"./fishing/textright.png": 39,
	"./fooddiary_icon.png": 88,
	"./foodjournal/10_fooddiary__may.jpg": 87,
	"./foodjournal/1_fooddiary__august.jpg": 78,
	"./foodjournal/2_fooddiary__september.jpg": 79,
	"./foodjournal/3_fooddiary__october.jpg": 80,
	"./foodjournal/4_fooddiary__november.jpg": 81,
	"./foodjournal/5_fooddiary__december.jpg": 82,
	"./foodjournal/6_fooddiary__january.jpg": 83,
	"./foodjournal/7_fooddiary__february.jpg": 84,
	"./foodjournal/8_fooddiary__march.jpg": 85,
	"./foodjournal/9_fooddiary__april.jpg": 86,
	"./foodjournal/fooddiary_cover.jpg": 76,
	"./foodjournal/fooddiary_coverback.jpg": 77,
	"./frog-background.svg": 173,
	"./frog-preview.svg": 50,
	"./frog.svg": 22,
	"./full-switch.svg": 37,
	"./icons/mute.svg": 174,
	"./icons/suitcase_closed.png": 175,
	"./icons/unmute.svg": 176,
	"./index-card.svg": 23,
	"./intro_box.png": 102,
	"./laptopPlaceholder.svg": 177,
	"./leftArrow.svg": 103,
	"./loading.svg": 98,
	"./maincookie.svg": 90,
	"./necklace.png": 93,
	"./nintendo.svg": 15,
	"./photos/done1.jpg": 56,
	"./photos/done1.svg": 55,
	"./photos/done2.svg": 57,
	"./photos/photo-background.svg": 178,
	"./photos/photospreview.svg": 54,
	"./photos/photostrip.jpg": 72,
	"./photos/photostrip.svg": 71,
	"./photos/polaroid2.jpg": 58,
	"./photos/polaroid3.jpg": 60,
	"./photos/polaroid3.svg": 59,
	"./photos/polaroid4.jpg": 62,
	"./photos/polaroid4.svg": 61,
	"./photos/polaroid5.jpg": 64,
	"./photos/polaroid5.svg": 63,
	"./photos/polaroid6.jpg": 66,
	"./photos/polaroid6.svg": 65,
	"./photos/polaroid7.jpg": 68,
	"./photos/polaroid7.svg": 67,
	"./photos/polaroid8.jpg": 70,
	"./photos/polaroid8.svg": 69,
	"./photos/postcard_back.jpg": 74,
	"./photos/postcard_back.svg": 73,
	"./photos/postcard_front.jpg": 75,
	"./plants/all-plants-background.png": 179,
	"./plants/plant-diary-preview.png": 89,
	"./plants/room [no animated plants].png": 49,
	"./rightArrow.svg": 104,
	"./seashell-box-closed.svg": 16,
	"./seashell-box-open.svg": 48,
	"./seashell_icon.png": 29,
	"./seashells (3)(1).png": 180,
	"./seashells/seashell1.svg": 41,
	"./seashells/seashell2.svg": 42,
	"./seashells/seashell3.svg": 43,
	"./seashells/seashell4.svg": 44,
	"./seashells/seashell5.svg": 45,
	"./seashells/seashell6.svg": 46,
	"./seashells/seashell7.svg": 47,
	"./skipButton.png": 105,
	"./suitcase_closed.png": 94,
	"./suitcase_openEMPTY.png": 95,
	"./switch.svg": 181,
	"./takeout_containers.png": 106,
	"./yearbook-icon.png": 107,
	"./yearbook.svg": 182,
	"./yearbook/drawings.png": 108,
	"./yearbook/link-arrow.svg": 183,
	"./yearbook/members/placeholder.png": 11,
	"./yearbook/signatures.png": 109,
	"./yearbook/yearbook-back.jpg": 110,
	"./yearbook/yearbook-cover.jpg": 111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 166;